import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import MyStaticDatePicker from 'src/components/widgets/my-static-date-picker';

const DynamicSearchDialog = ({
  open,
  handleClose,
  selectedFilter,
  updateInput, // Callback to parent
  children, // Dynamic view passed as a prop
  triggerReset, // Function to reset data by keys
}) => {
  const [searchDates, setSearchDates] = useState([]); // Initialize state for selected dates
  const [groupData, setGroupData] = useState(null); // Example for group state

  // Handle date selection and pass back to parent
  const handleDateSelection = (date) => {
    setSearchDates((prevDates) => {
      const updatedDates = new Set(prevDates); // Avoid duplicates
      updatedDates.add(date);
      const datesArray = Array.from(updatedDates);

      if (updateInput) {
        const json = datesArray.join(' ');
        updateInput({ date: json }); // Callback to parent with selected dates
      }

      return datesArray;
    });
  };

  // Reset specific data by keys
  useEffect(() => {
    if (triggerReset && typeof triggerReset === 'function') {
      triggerReset((keys) => {
        if (Array.isArray(keys)) {
          keys.forEach((key) => {
            if (key === 'date') {
              setSearchDates([]); // Clear date-specific state
              //if (updateInput) updateInput({ date: null }); // Notify parent
            }
            if (key === 'group') {
              setGroupData(null); // Clear group-specific state
              //if (updateInput) updateInput({ group: null }); // Notify parent
            }
            // Add more key handling logic as needed
          });
        }
      });
    }
  }, [triggerReset, updateInput]);

  const renderContent = () => {
    if (typeof children === 'function') {
      return children(updateInput); // Render children as a function with updateInput
    }

    if (selectedFilter === 'date') {
      return (
        <MyStaticDatePicker
          onAgree={(date) => {
            handleDateSelection(date); // Update parent with selected date
            handleClose(); // Close dialog
          }}
        />
      );
    }

    return children || <div>No content available for this filter.</div>; // Default fallback
  };

  return (
    <Dialog closeAfterTransition={false}
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {renderContent()}
    </Dialog>
  );
};

export default DynamicSearchDialog;
